// The overview card's frame and its loading shape, kept apart from the card
// itself so the route's fallback can show the same skeleton without pulling
// the whole overview into the main bundle.
import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { tokens } from '../../styles/tokens';

const c = tokens.colors;

export const sheetSx = {
  minWidth: 0, bgcolor: c.surface, border: `1px solid ${c.border}`, borderRadius: `${tokens.radius.xl}px`,
  // clip, not hidden: hidden would make the sheet a scroll container and
  // stop its header sticking under the top bar
  overflow: 'clip',
};

// cluster | what is wrong (one line per problem) | backlog | actions
export const NA_COLS = 'minmax(200px, 1.1fr) minmax(0, 3fr) 88px 128px';

/** The card's shape while loading; the route's own fallback uses it too, so
 * the page shows one skeleton from first paint until the data is in. */
export const QueueSkeleton = () => (
  <Box role="status" aria-label="Loading fleet health" sx={sheetSx}>
    <Box sx={{ px: 2, py: 1.5 }}><Skeleton variant="rounded" width={560} height={44} sx={{ maxWidth: '100%', borderRadius: '12px' }} /></Box>
    {[0, 1, 2].map((i) => (
      <Box key={i} sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: NA_COLS }, columnGap: 3, alignItems: 'start', px: 3, py: 2.5, borderTop: `1px solid ${c.borderLight}` }}>
        <Box><Skeleton width="60%" height={22} /><Skeleton width="45%" /></Box><Box><Skeleton width="85%" height={22} /><Skeleton width="40%" /></Box><Skeleton width={40} /><Skeleton width={120} height={30} />
      </Box>
    ))}
  </Box>
);
